import { render, staticRenderFns } from "./adminauth.vue?vue&type=template&id=67c5d065&scoped=true&"
import script from "./adminauth.vue?vue&type=script&lang=js&"
export * from "./adminauth.vue?vue&type=script&lang=js&"
import style0 from "./adminauth.vue?vue&type=style&index=0&id=67c5d065&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67c5d065",
  null
  
)

export default component.exports